import { AppleBook, AppleBooksResult } from "./types";
import { appleArtwork } from "../../../supabase/functions/_shared/bookCover";
import { plainTextFromHtml } from "@/utils/textCleaners";

export const transformAppleBookData = (result: AppleBooksResult): AppleBook | null => {
  if (!result.trackName || !result.artistName) {
    return null; // Invalid result
  }
  
  // Scale up the artwork URL for better quality
  return {
    id: result.trackId.toString(),
    title: result.trackName,
    author: result.artistName,
    // Shared with the Google transformer — it stripped tags but left
    // entities, so a synopsis could end "...called Unity.&#x60;".
    description: plainTextFromHtml(result.description),
    // 600px: sharp in cards; the lightbox asks appleArtwork for 1200.
    coverUrl: appleArtwork(result.artworkUrl100, 600),
    price: result.trackPrice ?? result.price,
    currency: result.currency,
    formattedPrice: result.formattedPrice,
    storeUrl: result.trackViewUrl
  };
};

export const generateAppleBooksWebUrl = (trackId: string, countryCode = 'gb'): string => {
  return `https://books.apple.com/${countryCode}/book/id${trackId}`;
};

export const generateAppleBooksDeepLink = (trackId: string): string => {
  return `ibooks://assetid/${trackId}`;
};

export const canOpenAppleBooksApp = (): boolean => {
  // Check if we're on iOS and can potentially open the Apple Books app
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  return isIOS;
};